import { ServiceContainerContext } from '../../context';
import { createUseServiceHook } from '../../container';

export const useService = createUseServiceHook(ServiceContainerContext);
